import { SiteCodes } from 'shared-types'

export const convertProductImageUrl = (imageUrl: string, siteCode: string) => {
  if (imageUrl.startsWith('http') || imageUrl.startsWith('data')) {
    return imageUrl
  }

  let baseUrl = ''

  if (siteCode === SiteCodes.RTM) {
    baseUrl = process.env.NEXT_PUBLIC_PRODUCT_BASE_IMG_URL_RTM || ''
  } else if (siteCode === SiteCodes.JaycarNz) {
    baseUrl = process.env.NEXT_PUBLIC_PRODUCT_BASE_IMG_URL_JNZ || ''
  } else {
    baseUrl = process.env.NEXT_PUBLIC_PRODUCT_BASE_IMG_URL_JAU || ''
  }

  return `${baseUrl}${imageUrl}`
}

export const convertProductResourceUrl = (
  resourceUrl: string,
  siteCode: string
) => {
  if (resourceUrl.startsWith('http') || resourceUrl.startsWith('data')) {
    return resourceUrl
  }

  let baseUrl = ''

  if (siteCode === SiteCodes.RTM) {
    baseUrl = process.env.NEXT_PUBLIC_PRODUCT_BASE_RESOURCE_URL_RTM || ''
  } else if (siteCode === SiteCodes.JaycarNz) {
    baseUrl = process.env.NEXT_PUBLIC_PRODUCT_BASE_RESOURCE_URL_JNZ || ''
  } else {
    baseUrl = process.env.NEXT_PUBLIC_PRODUCT_BASE_RESOURCE_URL_JAU || ''
  }

  return `${baseUrl}${resourceUrl}`
}
